// Module
var code = "<template><div id=\"iframe-host\" style=\"width: 100%; height: 100%; border: 0; flex-grow: 1; background-color: #121213;\"></div></template>";
// Exports
module.exports = code;